import React from 'react';
import PropTypes from 'prop-types';
import './PageLayout.scss';
import Header from '../Header';

export const PageLayout = ({ store, children }) => (
  <div className='page-layout'>
    <Header store={store} />
    {children}
  </div>
);

PageLayout.propTypes = {
  children: PropTypes.node,
  store: PropTypes.object,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/routes/user/layouts/PageLayout/PageLayout.js